import { call, takeLatest } from "redux-saga/effects";
import actionTypes from "../../actions/actionTypes";
import { deleteEventsDataEventCall } from "../../apis/wpApi/apiCalls";
import authUser from "../../apis/wpApi/authUser";
import { checkResponse, putError, putSuccess } from "../helpers";

function* deleteEvent(payload) {
    try {
        const { id } = yield payload.payload

        if(!id) {
            throw new Error('No id')
        }

        const apiKey = yield call(authUser.getToken)
        const response = yield call(deleteEventsDataEventCall, apiKey, {id: id})

        yield call(checkResponse, response)
        yield call(putSuccess, actionTypes.EVENTS_EVENTS_DELETE_SUCCESS, { data: response.data})
    } catch(e) {
        yield call(putError, actionTypes.EVENTS_EVENTS_DELETE_ERROR, e.message)
    }
}

function* watchEventDeleteRequest() {
    try {
        yield takeLatest(actionTypes.EVENTS_EVENTS_DELETE_REQUEST, deleteEvent)
    } catch(e) {
        console.log('error!!!!!', e.message)
    }
}


export default watchEventDeleteRequest